export default {
  getAll: 'ADMIN_MASS_MEDIA_GET_ALL',
  newNote: 'ADMIN_MASS_MEDIA_NEW_NOTE'
};
